import { router, Stack } from 'expo-router';
import * as React from 'react';
import {
    BackButton,
    ChevronLeftIcon,
    Icon,
    isWeb,
    useTheme,
    View,
} from 'smoothie';

import RedirectFullyAuthedUser from '../../auth/components/middleware/RedirectFullyAuthedUser';
import Screens from '../../common/types/Screens';

export default function SignInLayout() {
    const theme = useTheme();

    return (
        <RedirectFullyAuthedUser>
            <Stack
                screenOptions={{
                    // @ts-expect-error - ts not happy with use of viewport units for web.
                    contentStyle: {
                        backgroundColor: theme.background.get(),
                        ...(isWeb && {
                            width: '94vw',
                            maxWidth: 800,
                            height: 'auto',
                            maxHeight: 700,
                            marginHorizontal: 'auto',
                            marginVertical: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 32,
                        }),
                    },
                    headerStyle: {
                        backgroundColor: theme.background.get(),
                    },
                    headerShown: false,
                    headerShadowVisible: false,
                    headerBackTitleVisible: false,
                    headerBackVisible: false,
                    headerLeft: () => {
                        return <BackButton fallbackRoute="/sign-in/email" />;
                    },
                    headerRight: () => null,
                }}
            >
                <Stack.Screen
                    name={Screens.SignIn.ForgotPassword.Start}
                    options={{
                        headerShown: true,
                        headerTitle: '',
                    }}
                />
                <Stack.Screen
                    name={Screens.SignIn.ForgotPassword.Finish}
                    options={{
                        headerTitle: '',
                        headerLeft: () => {
                            return (
                                <View
                                    padding={10}
                                    onPress={() => {
                                        if (router.canGoBack()) {
                                            router.back();
                                        } else {
                                            router.replace(
                                                '/sign-in/forgot-password',
                                            );
                                        }
                                    }}
                                >
                                    <Icon
                                        icon={ChevronLeftIcon}
                                        size={12}
                                        color="$black"
                                    />
                                </View>
                            );
                        },
                        headerRight: () => null,
                    }}
                />
            </Stack>
        </RedirectFullyAuthedUser>
    );
}
